// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"f8e970cc","216":"ed1afc09","558":"731cebbd","572":"afdfc0fb","730":"ca3d6f8c","850":"fe2ecc81"}[chunkId] + ".chunk.js";
};